import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import Box from '@mui/material/Box';
import dayjs from "dayjs";
import Typography from '@mui/material/Typography';
import { DateCalendar  } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import updateLocale from 'dayjs/plugin/updateLocale'
dayjs.extend(updateLocale);
import 'dayjs/locale/zh-tw';

const Index = (props: any) => {
  const { config, insideRef } = props;
  const itemRef = useRef<any>(null);
  const [year, setYear] = useState<any>("");
  const [month, setMonth] = useState<any>("");
  const [day, setDay] = useState<any>("");
  const [weekday, setWeekday] = useState<any>("");
  const [showCalendar, setShowCalendar] = useState(true);
  const [Weekstart, setWeekstart] = useState(1);
  const [calendarKey, setCalendarKey] = useState(0);

  useEffect(() => {
    dayjs.locale('zh-tw');
    setYear(dayjs().year());
    setMonth(dayjs().format('MMMM'));
    setDay(dayjs().date());
    setWeekday(dayjs().format('dddd'));
  }, []);

  useEffect(() => {
    if (config.data.Monday) {
      setWeekstart(1);
    } else if (config.data.Sunday) {
      setWeekstart(0);
    }
  }, [config.data?.Monday, config.data?.Sunday]);

  useEffect(() => {
    if (itemRef.current) {
      const { offsetWidth: w, offsetHeight: h } = itemRef.current;
      const aspectRatio = w / h;
      setShowCalendar(aspectRatio >= 1);
    }
  }, [config]);

  useEffect(() => {
    dayjs.updateLocale('zh-tw', {
      weekStart: Weekstart
    });
    setCalendarKey(calendarKey + 1);
  }, [Weekstart]);

  const toNumber = (str: string) => {
    return Number(str.split("px")[0]);
  };

  return (
    <React.Fragment>
      <div className="componentCore " style={{ height: '100%', width: '100%', position: 'absolute' }} ref={itemRef}>
        {showCalendar? (
          <Box className="screen-calendar core-color">
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
              <DateCalendar readOnly key={calendarKey} />
            </LocalizationProvider>
          </Box>
        ) : (
          <Box className="screen-calendar-mini core-color" style={{ textAlign: 'center' }}>
            <Box>
              <Typography>
                今日是 {weekday}
              </Typography>
            </Box>
            <Box className="miniNumber">
              <Typography color='blue'>
                {day}
              </Typography>
            </Box>
            <Box>
              <Typography>
                {month} {year}
              </Typography>
            </Box>
          </Box>
        )}
      </div>
    </React.Fragment>
  );
};

export default memo(Index);